import React, { useState } from 'react';

import { IStorytellingFields } from '../../../types/contentful';

import RichText from '../RichText';
import { Collapsible } from '../Collapsible';
import { Asset } from '../AtomicComponents/Asset';

import cx from 'classnames';

interface Props extends IStorytellingFields {
  sysId?: string;
}

export function Storytelling({
  backgroundColor,
  roundedImageOption,
  headingText,
  image,
  // In Contentful, "left" is mapped to true and "right" is vice versa.
  imageOrientation = true,
  collapsibles,
  button,
  images,
  sysId,
  anchorLink
}: Props) {
  const [currentImageIndex, setCurrentImageIndex] = useState(-1);

  const toggleCollapsible = (index: number) => {
    if (currentImageIndex === index) {
      setCurrentImageIndex(-1);
    } else {
      setCurrentImageIndex(index);
    }
  };

  return (
    <>
      <div
        className={cx('block-container', {
          'py-5 tablet:py-10 desktop:py-15': backgroundColor
        })}
        data-blockid="storytelling"
        data-testid="storytelling"
        id={anchorLink ?? `${sysId}`}
      >
        <div
          className={cx('layout layout-padding flex-col gap-y-10', {
            'tablet:flex-row': imageOrientation,
            'tablet:flex-row-reverse': !imageOrientation
          })}
          data-testid="storytelling-layout"
          style={{
            backgroundColor: backgroundColor ?? 'transparent',
            alignItems: 'normal'
          }}
        >
          <div className="column w-full justify-center tablet:w-1/2 tablet:pr-3 desktop:pr-4">
            <div className="relative w-full">
              {image && (
                <Asset
                  asset={image}
                  className={cx(
                    'z-0 mx-auto max-w-full grow desktop:mr-4 desktop:max-w-[480px]',
                    images
                      ? currentImageIndex === -1
                        ? 'block'
                        : 'hidden'
                      : 'block',
                    {
                      'overflow-hidden rounded-3xl tablet:rounded-4xl':
                        roundedImageOption
                    }
                  )}
                />
              )}
            </div>
            {images &&
              images.map((img, index: number) => (
                <div key={index} className="relative w-full">
                  <Asset
                    asset={img}
                    className={cx(
                      'z-0 mx-auto max-w-full grow desktop:mr-4 desktop:max-w-[480px]',
                      currentImageIndex === index ? 'block' : 'hidden',
                      {
                        'overflow-hidden rounded-3xl tablet:rounded-4xl':
                          roundedImageOption
                      }
                    )}
                  />
                </div>
              ))}
          </div>
          <div className="column tablet:grow-1 w-full justify-center tablet:mt-0 tablet:w-1/2 tablet:pl-3 desktop:grow-0 desktop:pl-4">
            <div className="border-box tablet:grow-1 w-[480px]">
              <div className="pb-8">
                <div className="heading-2">{headingText}</div>
              </div>
              <div className="mb-8">
                {collapsibles &&
                  collapsibles.map(({ fields }, index: number) => {
                    return (
                      fields && (
                        <Collapsible
                          {...fields}
                          key={index}
                          isOpen={currentImageIndex === index}
                          onClick={() => toggleCollapsible(index)}
                        />
                      )
                    );
                  })}
              </div>
              {button && (
                <div className="mt-10">
                  <RichText data={button} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
